import { render, staticRenderFns } from "./CreateInvestorAccountDetails.vue?vue&type=template&id=db49bbbe"
import script from "./CreateInvestorAccountDetails.vue?vue&type=script&lang=js"
export * from "./CreateInvestorAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports